import React, { useState, useEffect } from "react";
import { Modal, ModalHeader, ModalBody, Table } from "reactstrap";
import { addUser, deleteUser, getUser, getUserByEmail, updateUser } from "../../../Services/DataServices";
import GenericTable from "./GenericTable";
import { toast } from 'react-toastify';
import Loader from "../../../Components/Common/Loader";
import { useNavigate } from "react-router-dom";
import AddModal from "../../Forms/AddModal";
import EditableModal from "../../Forms/EditableModal";
import DeleteModal from "../../../Components/Common/DeleteModal";

const UserDataCont = ({ isAddModalOpen, closeModal, setAddModalOpen, setNewUser, newUser , openAddModal }) => {

  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showPassword, setShowPassword] = useState(false);
  const [totalItems, setTotalItems] = useState();

  let limit = 50;

  const fetchData = async (page = 1) => {
    setLoading(true);
    const { status, result } = await getUser(searchQuery, page, limit);
    
    status && setData(result.result);
    setTotalPages(result?.totalPages);
    setTotalItems(result?.totalItems)
setTimeout(() => {
  setLoading(false);
}, 100);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    fetchData(currentPage , searchQuery);
  };

  useEffect(() => {
    fetchData(currentPage, searchQuery);
  }, [currentPage, searchQuery]);


  const handleEdit = (item) => {
    setSelectedItem(item);
    setIsEditModalOpen(true);
  };

  const closeEditModal = () => {
    setIsEditModalOpen(false);
  };

  const handleDelete = (item) => {
    setSelectedItem(item);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    try {
      const response = await updateUser(selectedItem);
      setData((prevData) => {
        const updatedData = prevData.map((user) => {
          if (user._id === response.result.result._id) {
            return response.result.result;
          }
          return user;
        });
        toast.success('User edited successfully!')
        return updatedData;

      });
      closeEditModal();
    } catch (error) {
      toast.error('Error updating user!')
      console.error("Error updating user:", error);
    }
  };

  const handleDeleteData = async (event) => {
    event.preventDefault();
    try {
      const response = await deleteUser(selectedItem);
      if (response.result.response === true) {
        fetchData(currentPage);
        toast.success('User deleted successfully!')
        closeDeleteModal();
      }
      else {
        toast.error('Error deleting user!')
      }
    } catch (error) {
      toast.error('Error deleting user!')
      console.error("Error deleting user:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const handleSubmit = async (data) => {
    try {
      const response = await addUser(data);
      
      if (response ) {
        closeModal();
        toast.success('User Added successfully!')
      }
    } catch (err) {
      toast.error("Failed to upload file.");
    } finally {
      setLoading(false);
      fetchData(currentPage)
      setAddModalOpen(false);
    }
  };

  const columnList = [
    // {
    //   label: "Name",
    //   field: "name",
    // },

    {
      label: "First Name",
      field: "firstName",
    },
    {
      label: "Last Name",
      field: "lastName",
    },
    {
      label: "Email",
      field: "email",
    },
    {
      label: "Password",
      field: "password",
    },
    {
      label: "Role",
      field: "role",
    }
  ];

  const handleNewUserChange = (event) => {
    let value = event.target.value;
    if (event.target.name === 'email') {
      value = value.toLowerCase();
    }
    setNewUser({
      ...newUser,
      [event.target.name]: value,
    });
  };
  return (
    <div>
      {/* {loading ? (
        <div>
          <Loader />
        </div>
      ) : (
        <></>
      )} */}
      <div style={{ display: "flex", marginBottom: "1%" }}>
        {/* <form onSubmit={handleSearch} style={{ width: "90%" }}>
          <input
            type="text"
            placeholder="Search by email"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            style={{ width: "60%", marginRight: 20 }}
          />
                        </form> */}
                         <form onClick={handleSearch} style={{ width: "100%", display: "flex", alignItems: "center" }}>
                    <input
                        type="text"
                        placeholder={`Search by  email`}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ width: "60%", marginRight: 20, padding: "8px", borderRadius: "5px", border: "1px solid gray" }}
                    />
                </form>
                          <button
                          onClick={openAddModal}
                          style={{ padding: 7, backgroundColor: "#4b38b3", height: 40, whiteSpace:'nowrap' }}
                          //  backgroundColor: "#1eaf58"
                          >
                        Add User
                          </button>
      </div>
     {loading ? (
       <Loader/>
     ):(
      <GenericTable
       {...{
         columnList,
         data,
         handlePageChange,
         totalPages,
         handleEdit,
         handleDelete,
         currentPage,
         totalItems
       }}
     />
     ) }
      <AddModal
        isOpen={isAddModalOpen}
        toggleModal={closeModal}
        fieldData={newUser}
        setNewUser={setNewUser}
        handleSubmit={handleSubmit}
        handleChange={handleNewUserChange}
        modalTitle="Add User"
        btnLabel="Add User"
      />
      <EditableModal
        {...{
          isEditModalOpen,
          closeEditModal,
          selectedItem,
          handleUpdate,
          setSelectedItem,
          columnList,
          showPassword,
          setShowPassword
        }}
      />
      <DeleteModal
        {...{
          isDeleteModalOpen,
          closeDeleteModal,
          selectedItem,
          handleDeleteData
        }} />
    </div>
  );
};

export default UserDataCont;
